<template>
  <v-dialog
    v-model="localShowDialog"
    max-width="500px"
  >
    <v-form ref="formRole" @submit.prevent="processRole">
      <v-card>
        <v-app-bar color="secondary" dark flat dense>
          <span>User role</span>
          <v-spacer />
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <v-card-text class="pt-6">
          <v-row>
            <v-col cols="12">
              <v-text-field
                ref="name"
                v-model="name"
                label="Name"
                placeholder="Name"
                dense
                clearable
                required
                counter
                maxlength="50"
                :rules="[rules.required, rules.minlength]"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="description"
                label="Description"
                placeholder="Description"
                dense
                clearable
                required
                counter
                maxlength="200"
                :rules="[rules.required, rules.minlength]"
              />
            </v-col>
            <v-col cols="12">
              <v-checkbox
                v-model="internal"
                label="Internal"
                dense
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close" :disabled="loading">Cancel</v-btn>
          <v-btn type="submit" color="primary" :disabled="loading"
            >Save
            <v-progress-circular
              indeterminate
              :size="20"
              v-if="loading"
            ></v-progress-circular
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  emits: ["close", "submit"],
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    role: {
      type: Object,
      default: () => ({
        roleId: null,
        name: "",
        description: "",
        internal: false
      }),
    },
  },
  data: () => ({
    roleId: null,
    name: "",
    description: "",
    internal: false,
    localShowDialog: false,
    rules: {
      required: (value) => !!value || "Required",
      minlength: (value) => value.length >= 3 || "Minimum 3 characters",
    },
  }),
  methods: {
    close() {
      this.$emit("close");
    },
    async processRole() {
      if (!this.$refs.formRole.validate()) {
        return;
      }

      const role = {
        roleId: this.roleId,
        name: this.name,
        description: this.description,
        internal: this.internal
      };

      this.$emit("submit", role);
    },
  },
  mounted() {
    this.localShowDialog = this.showDialog;
    this.roleId = this.role.roleId;
    this.name = this.role.name;
    this.description = this.role.description;
    this.internal = this.role.internal;
  },
  watch: {
    localShowDialog(newVal) {
      if (!newVal) {
        this.close();
      }
    }
  }
};
</script>